export { FacilitiesSearchInitialResultContainer as default } from "containers/FacilitiesContainer";
